import gql from "graphql-tag";

export const DISPLAY_ALERT = gql`
  {
    displayAlert @client
    alertMessage @client
    variant @client
  }
`;

export const NOTIFICATION = gql`
  query notification {
    notification @client
  }
`;

export const ALERT = gql`
  {
    alert @client {
      type
      message
      opened
    }
  }
`;

export const USER_ENABLED = gql`
  {
    userEnabled @client
  }
`;

export const FOLDER_OWNER = gql`
  {
    folderOwner @client
  }
`;

export const FILE_DOWNLOADS = gql`
  {
    fileDownloads @client {
      id
      filename
      progress
    }
  }
`;

export const SHOW_DOWNLOAD = gql`
  {
    showDownload @client
  }
`;

export const SHARE_ID = gql`
  {
    shareId @client
  }
`;

export const SHARE_TYPE = gql`
  {
    shareType @client
  }
`;
export const SHOW_USER_SHARE_MODAL = gql`
  {
    showUserShareModal @client
  }
`;

export const SHOW_LOGIN_MODAL = gql`
  {
    showLoginModal @client
  }
`;

export const TOKEN = gql`
  {
    token @client
  }
`;

export const IS_LOGGED_IN = gql`
  {
    isLoggedIn @client
  }
`;

export const TEST_VIEW_TITLE = gql`
  {
    testViewTitle @client
  }
`;
export const SEARCH_LIKE = gql`
  {
    searchLike @client
  }
`;

export const PAGINATED_VIEWS = gql`
  {
    paginatedViews @client {
      view
      page
    }
  }
`;

const schema = {
  notification: NOTIFICATION,
  alert: ALERT,
  folderOwner: FOLDER_OWNER,
  userEnabled: USER_ENABLED,
  fileDownloads: FILE_DOWNLOADS,
  showDownload: SHOW_DOWNLOAD,
  shareId: SHARE_ID,
  shareType: SHARE_TYPE,
  showUserShareModal: SHOW_USER_SHARE_MODAL,
  token: TOKEN,
  isLoggedIn: IS_LOGGED_IN,
  showLoginModal: SHOW_LOGIN_MODAL,
  testViewTitle: TEST_VIEW_TITLE,
  searchLike: SEARCH_LIKE,
  paginatedViews: PAGINATED_VIEWS,
};

export default schema;
